<div *ngIf="loading" class="alert-loader text-center">
  <img src="assets/img/spinner.svg"/>
</div>
<div class="notifications-container"  *ngIf="!loading">
  <app-accordion [accordion]="notificationAccordionData" [accordionController]=false>
      <app-accordion-list *ngFor="let notification of notificationAccordionData" [option]="notification" [listLength]="lazyLoadAlerts.length" 
        [isSubAccordion]=true (onLoadComplete)="showAlert()" (selectedTab)="accordionOpen($event)" [tabInside]=true>
        <ul class="notification-list">
          <li *ngFor="let alert of lazyLoadAlerts; let index=index;">
            <div id="{{'alert'+ alert.id}}" class="alert-list">
              <div class="notification-header">{{alert.title}}</div>
              <div class="dismiss-alert" [class.disabled]="addpAllow"> <!--*hasPermission="'alerts.action'" -->
                <i tabindex="0" class="icon-close close-icon" (click)="removeAlert(notification, index, $event)"
                 aria-label="Close this alert." (keydown)="handleKeypress(notification, index, $event)" role="img"></i>
              </div>
              <div class="notification-description">
                <div>{{alert.description}}</div>
                <div *ngFor="let link of alert.actionLink; let i=index;" class="action-links">
                  <span *ngIf="i && addpAllow" class="line-separator"></span>
                  <a class="btn btn-link" [class.disabled]="(addpAllow || (addpAuthority =='PARTIAL' && link.label == 'Go to Apple certificate website'))" (click)="navigate(notification, index, $event)" tabindex="0" (keydown)="navigate(notification, index, $event)">{{link.label}}</a>
                </div>
              </div>
              <div class="horizontal-separator"></div>
            </div>
          </li>
        </ul>
        <div class="more-alerts text-center">
            <a *ngIf="showSeeMore" class="btn btn-link showMore" (click)="showMoreAlerts($event)" tabindex="0" (keydown)="handleKeydown($event)">
              View more alerts <i class="icon-down" aria-label="View more alerts."></i>
            </a>
<!--View fewer alerts-->
            <a *ngIf="!showSeeMore && this.lazyLoadAlerts.length > 0" class="btn btn-link showLess" (click)="showFewerAlerts($event)" tabindex="0" (keydown)="handleKeydown($event)">
              View fewer alerts <i class="icon-up" aria-label="View fewer alerts."></i>
            </a>
            
        </div>
      </app-accordion-list>
  </app-accordion>
</div>